export const GET_ADMIN_CARRIER_REQUEST = "GET_ADMIN_CARRIER_REQUEST";
export const GET_ADMIN_CARRIER_SUCCESS = "GET_ADMIN_CARRIER_SUCCESS";
export const GET_ADMIN_CARRIER_FAIL = "GET_ADMIN_CARRIER_FAIL";

export const CREATE_ADMIN_CARRIER_REQUEST = "CREATE_ADMIN_CARRIER_REQUEST";
export const CREATE_ADMIN_CARRIER_SUCCESS = "CREATE_ADMIN_CARRIER_SUCCESS";
export const CREATE_ADMIN_CARRIER_FAIL = "CREATE_ADMIN_CARRIER_FAIL";

export const UPDATE_ADMIN_CARRIER_REQUEST = "UPDATE_ADMIN_CARRIER_REQUEST";
export const UPDATE_ADMIN_CARRIER_SUCCESS = "UPDATE_ADMIN_CARRIER_SUCCESS";
export const UPDATE_ADMIN_CARRIER_FAIL = "UPDATE_ADMIN_CARRIER_FAIL";

export const DELETE_ADMIN_CARRIER_REQUEST = "DELETE_ADMIN_CARRIER_REQUEST";
export const DELETE_ADMIN_CARRIER_SUCCESS = "DELETE_ADMIN_CARRIER_SUCCESS";
export const DELETE_ADMIN_CARRIER_FAIL = "DELETE_ADMIN_CARRIER_FAIL";